module.exports = __webpack_public_path__ + "static/media/ketozocha.20b91a20.jpg";